import "react-responsive-modal/styles.css";
import "./style.css";
import { Modal } from "react-responsive-modal";
import { ModalHeading } from "../../shared/components/modalHeading";
import { formatDate } from "../../shared/utils/dateFormat";
import { useState } from "react";

export const ViewVocabulary = ({ open, onCloseModal, vocabularyData }) => {
  const [activeTab, setActiveTabe] = useState(1);
  return (
    <div>
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        styles={{ width: "60% !important" }}
      >
        <div className="note-card">
          <ModalHeading heading={"Note Details"} />
          <div className="card-body p-4">
            <ul className="nav nav-tabs mb-4">
              <li
                className="nav-item"
                onClick={() => {
                  setActiveTabe(1);
                }}
              >
                <a
                  className={`nav-link ${activeTab === 1 ? "active" : ""}`}
                  aria-current="page"
                  href="javascript:;"
                >
                  My Notebook
                </a>
              </li>
              <li
                className={`nav-link ${activeTab === 2 ? "active" : ""}`}
                onClick={() => {
                  setActiveTabe(2);
                }}
              >
                <a
                  className="nav-link "
                  aria-current="page"
                  href="javascript:;"
                >
                  Notebook Feedback
                </a>
              </li>
            </ul>
            {activeTab === 1 ? (
              <>
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <div className="note-date mb-2">
                      <span>
                        Created On : {formatDate(vocabularyData?.created_at)}
                      </span>
                    </div>
                    <h5 className="mb-2"> {vocabularyData?.title}</h5>
                  </div>
                </div>
                <div
                  className="text-muted"
                  style={{ height: "500px", overflow: "auto" }}
                  dangerouslySetInnerHTML={{
                    __html: vocabularyData?.description,
                  }}
                />
              </>
            ) : (
              <>
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <div className="note-date mb-2">
                      {vocabularyData?.feedback_at && (
                        <span>
                          Review Date :{formatDate(vocabularyData?.feedback_at)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="text-muted"
                  style={{ height: "500px", overflow: "auto" }}
                  dangerouslySetInnerHTML={{
                    __html: vocabularyData?.feedback,
                  }}
                />
              </>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};
